/* NASS header language globe: opens and closes the dropdown. Choosing a language is a plain submit of
   Shopify's localization form, so the switch itself needs no JavaScript. */
(function () {
  function init(root) {
    var toggle = root.querySelector('[data-nass-lang-toggle]');
    var panel = root.querySelector('[data-nass-lang-panel]');
    if (!toggle || !panel) return;

    function options() {
      return Array.prototype.slice.call(panel.querySelectorAll('.nass-lang__option'));
    }

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      var current = panel.querySelector('[aria-current="true"]') || options()[0];
      if (current) current.focus();
    }

    function close(returnFocus) {
      if (panel.hidden) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      if (panel.hidden) {
        open();
      } else {
        close(false);
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close(false);
    });

    root.addEventListener('focusout', function (event) {
      if (event.relatedTarget && !root.contains(event.relatedTarget)) close(false);
    });

    root.addEventListener('keydown', function (event) {
      if (panel.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close(true);
        return;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        var list = options();
        var index = list.indexOf(document.activeElement);
        var next = event.key === 'ArrowDown' ? index + 1 : index - 1;
        if (next < 0) next = list.length - 1;
        if (next >= list.length) next = 0;
        event.preventDefault();
        list[next].focus();
      }
    });
  }

  document.querySelectorAll('[data-nass-lang]').forEach(init);
})();
